interface IGetNoteResponse {
    NoteSummary: IPlayerNote;
}

interface IGetNoteDetailResponse {
    NoteDetail: IPlayerNote;
}

interface IGetNotesResponse {
    NoteSummaries: IPlayerNote[];
}

interface IPostNoteRequest {
    PlayerUsername: string;
    Value: string;
}

interface IPostNoteResponse {
    NoteId: string;
}

interface IPutNoteRequest {
    PlayerUsername: string;
    Value: string;
}

interface IPutNoteResponse {
    NewNoteId: string;
}


interface IPlayerNote {
    NoteId: string;
    Value: string;
    CreatedDate: string;
    CreatedBy: string;
}

interface IPlayerNoteUpdate extends IPlayerNote {
    PlayerUsername: string;
    IsDeleted: boolean;
}

class PlayerNote implements IPostNoteRequest {
    public PlayerUsername: string;
    public Value: string;
    public CreatedBy: string;

  constructor(playerUsername?: string, value?: string, createdBy?: string) {
    this.PlayerUsername = playerUsername || '';
    this.Value = value || '';
  }
}


export { IGetNoteResponse, IGetNoteDetailResponse, IGetNotesResponse, IPostNoteRequest, IPostNoteResponse, IPutNoteRequest, IPutNoteResponse,
        PlayerNote , IPlayerNote, IPlayerNoteUpdate};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/models/player-notes-model.ts